<h3 class="title configurator-title">{{ 'fence.summary.title' | translate }}</h3>

<ng-casto-loader *ngIf="!configuration.resume"></ng-casto-loader>

<ng-container *ngIf="configuration.resume">
  <div class="summary-container shadow">
    <h4 class="title summary-title">{{ 'fence.summary.location' | translate }}</h4>
    <div class="summary-infos">
      <p class="info">{{ currentLang === 'fr' ? configuration.location.nameFr : configuration.location.nameEn }}</p>
    </div>
  </div>

  <div class="summary-container shadow mt-4">
    <h4 class="title summary-title">{{ 'fence.summary.configuration' | translate }}</h4>
    <div class="summary-infos">
      <p class="info">{{ currentLang === 'fr' ? configuration.shape.nameFr : configuration.shape.nameEn }}</p>
      <ng-container *ngIf="configuration.shape.isFree">
        <p class="info">{{ configuration.sides.length }} {{ 'fence.summary.side-count' | translate }}</p>
      </ng-container>
      <p class="info">
        {{ 'fence.summary.total-length' | translate }} : {{ totalLength | convertDistance: false : 100 }} m
      </p>
    </div>
  </div>

  <ng-container *ngFor="let product of products">
    <div class="summary-container shadow mt-4">
      <h4 class="title summary-title">{{ currentLang === 'fr' ? product.categoryNameFr : product.categoryNameEn }}</h4>
      <div class="summary-infos">
        <p class="info" *ngFor="let item of product.items">
          <span
            >{{ currentLang === 'fr' ? item.nameFr : item.nameEn }} : {{ item.quantity }}
            {{ item.additionalInfo }}</span
          >
        </p>
      </div>
    </div>
  </ng-container>

  <div class="summary-container prices-container shadow mt-4">
    <div class="price-row">
      <h4 class="title summary-title">{{ 'fence.summary.total-without-vat' | translate }} :</h4>
      <p class="info">{{ configuration.resume.totalHT | number: '1.2-2' : 'fr' }} €</p>
    </div>
    <div class="price-row">
      <h4 class="title summary-title">{{ 'fence.summary.vat-total' | translate }} :</h4>
      <p class="info">{{ configuration.resume.totalTVA | number: '1.2-2' : 'fr' }} €</p>
    </div>
    <div class="price-row principale">
      <h4 class="title summary-title">{{ 'fence.summary.total-with-vat' | translate }} :</h4>
      <p class="info">{{ configuration.resume.totalPV | number: '1.2-2' : 'fr' }} €</p>
    </div>
  </div>
</ng-container>
